// ABOUTME: Help-icon explainer for the return-line assessment step in ReturnsToProcessView.
// ABOUTME: Explains accepted/rejected counts and when "not everything received" applies.

import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ExplainerModal from "../../../../theme/Modal/ExplainerModal/ExplainerModal";
import ExplainerBox from "../../../../theme/Modal/ExplainerModal/ExplainerBox";

const EMReturnProcessing = (props) => {
    const { t } = useTranslation();

    return (
        <ExplainerModal>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                }}
            >
                <ExplainerBox
                    variant="green"
                    title={t("accepted")}
                    text={"return_processing_explainer_accepted"}
                />
                <ExplainerBox
                    variant="red"
                    title={t("rejected")}
                    text={"return_processing_explainer_rejected"}
                />
                <ExplainerBox
                    title={t("not_everything_received")}
                    text={"return_processing_explainer_not_everything_received"}
                />
                <ExplainerBox
                    title={t("more_received_than_expected")}
                    text={"return_processing_explainer_more_received"}
                />
            </Box>
        </ExplainerModal>
    );
}

export default EMReturnProcessing;
